import { ProjectAttachmentTypeBase } from './base/project-attachment-type-base';

export class ProjectAttachmentType extends ProjectAttachmentTypeBase { }